import React from 'react';
import { ArrowRightIcon, CheckCircle2Icon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CtaButtonProps = {
  label: string;
  subtext?: string;
  variant?: 'primary' | 'outline';
  className?: string;
};
export function CtaButton({
  label,
  subtext,
  variant = 'primary',
  className = ''
}: CtaButtonProps) {
  const handleClick = () => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'InitiateCheckout');
    }
  };
  const base = 'group flex w-full items-center justify-center gap-2.5 rounded-2xl px-5 py-4 text-center text-[15px] font-extrabold uppercase leading-tight tracking-wide transition-[transform,background-color,box-shadow] duration-200 ease-out active:scale-[0.98] sm:text-lg sm:py-5';
  const styles = variant === 'primary' ? 'bg-rose text-white shadow-cta hover:bg-rose-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-rose' : 'border-2 border-navy bg-white text-navy hover:bg-navy hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-navy';
  return <div className={`w-full ${className}`} data-id="element-29" data-mp="3a0knz1p1esv8">
      <a href={CHECKOUT_URL} onClick={handleClick} className={`${base} ${styles}`} target="_self" rel="noopener" data-id="element-30" data-mp="3exks372btljp">
        {variant === 'primary' ? <CheckCircle2Icon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-31" data-mp="3owtijpxzgi1b" /> : null}
        <span data-id="element-32" data-mp="3swu03jgdp9cl">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-33" data-mp="3sw2duz8o8nyz" />
      </a>
      {subtext ? <p className="mt-3 text-center text-[12.5px] font-medium leading-relaxed text-navy/65 sm:text-sm" data-id="element-34" data-mp="6hj27ab2zmw7">
          {subtext}
        </p> : null}
    </div>;
}